export const ROLE_NAMES = [
    'admin',
    'projektleiter',
    'projektmitarbeiter',
];
/** German labels for the user interface. */
export const ROLE_LABELS = {
    admin: 'Administration',
    projektleiter: 'Projektleitung',
    projektmitarbeiter: 'Projektmitarbeit',
};
export function isRoleName(value) {
    return ROLE_NAMES.includes(value);
}
/**
 * Permissions the core itself contributes. Feature modules add their own
 * through their manifest (see ADR 0002).
 */
export const CORE_PERMISSIONS = [
    'projects.read',
    'projects.write',
    'projects.delete',
    'users.manage',
    'modules.manage',
    // Changing the office-wide reference data: benchmark catalog, regional
    // factors, price indices, DIN texts, text libraries (ADR 0020).
    'library.manage',
];
/**
 * What a person is called in the interface: the chosen short name, or the
 * first name if none was chosen. `name` is the full name.
 */
export function callName(name, nickname) {
    const chosen = nickname?.trim();
    if (chosen)
        return chosen;
    return name.trim().split(/\s+/)[0] ?? name;
}
/** "A, SK" or "A/SK" → ["A", "SK"]. */
export function splitOwnerCodes(input) {
    return (input ?? '').split(/[\s,;/+&]+/).map((c) => c.trim()).filter(Boolean);
}
/**
 * Whether a task's owner ("A/S/AG", "A + S", "Kiefer") names one of these
 * codes. Compared as whole codes, case-insensitive: "A" is not in "AG".
 */
export function isOwnedBy(owner, codes) {
    if (!owner || codes.length === 0)
        return false;
    const parts = new Set(splitOwnerCodes(owner).map((c) => c.toLowerCase()));
    return codes.some((c) => parts.has(c.toLowerCase()));
}
//# sourceMappingURL=auth.js.map